import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        addHousePinData(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/v1/house-pin/add`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addFAQ(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                .post(`/v1/house-pin/faq/add`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        fetchFAQs(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .post(`/v1/house-pin/faq/get`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateFAQ(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                .post(`/v1/house-pin/faq/update`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateOrderingFAQ(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                .post(`/v1/house-pin/faq/updateOrdering`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deleteFAQ(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                .delete(`/v1/house-pin/faq/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        fetchHousePinDetailById(ctx, housePinId){
            return new Promise((resolve, reject) => {
                axios
                .get(`/v1/house-pin/${housePinId}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        AddBuilding(ctx, queryParams){
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                .post(`/house-pin/v1/add-building`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        fetchBuilding(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .get(`/house-pin/v1/get-building/${data}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateBuilding(ctx,queryParams){
            var data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                .post(`/house-pin/v1/update-building/${queryParams.id}`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        orderingBuilding(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .post(`/house-pin/v1/ordering-building`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deleteBuilding(ctx, queryParams){
            return new Promise((resolve, reject) => {
                axios
                .delete(`/house-pin/v1/remove-building/${queryParams.id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        orderingFloorplan(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .post(`/house-pin/v1/floorplan/ordering`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deleteFloorplan(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                .delete(`/house-pin/v1/floorplan/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}